import { call, put, takeEvery } from "redux-saga/effects";
import { rootActions } from "../../actions/rootActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { chuongTrinhDaoTaoChiTietApi } from "../../../api/chuong-trinh-dao-tao/chuongTrinhDaoTaoChiTietApi";
import { eChuongTrinhDaoTaoChiTietActionIds, IChuongTrinhDaoTaoChiTietActionTypeBase, IChuongTrinhDaoTaoChiTietActionTypes } from "../../action-types/chuong-trinh-dao-tao/IChuongTrinhDaoTaoChiTietActions";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { IChuongTrinhDaoTaoChiTietUpdateCongThucRequest } from "../../../model/request/chuong-trinh-dao-tao/IChuongTrinhDaoTaoChiTietUpdateCongThucRequest";

export function* chuongTrinhDaoTaoChiTietSaga(): any {
    yield takeEvery(eChuongTrinhDaoTaoChiTietActionIds.LOAD_BY_CTDT_START, loadWorker);
    yield takeEvery(eChuongTrinhDaoTaoChiTietActionIds.UPDATE_CONG_THUC_START, updateCongThucWorker);
}

function* loadWorker(action: IChuongTrinhDaoTaoChiTietActionTypes): any {
    const id_dt = action.payload as number;
    const res: IBaseResponse = yield call(chuongTrinhDaoTaoChiTietApi.SelectByChuongTrinhDaoTao, id_dt);
  
    if (res.is_success) {
        
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.LOAD_BY_CTDT_SUCCESS({
            id_dt,
            data: {
                chuongTrinhDaoTaoChiTiets: toLowerCaseDeep(res.data.chuongTrinhDaoTaoChiTiets),
                chuongTrinhDaoTaoRangBuocs: toLowerCaseDeep(res.data.chuongTrinhDaoTaoRangBuocs),
                chuongTrinhDaoTaoNhomTuChons: toLowerCaseDeep(res.data.chuongTrinhDaoTaoNhomTuChons)
            }
    }));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chiTiet.LOAD_BY_CTDT_ERROR({
                id_dt,
                data: res.message ?? "Có lỗi"
            })
        );
    }
}

function* updateCongThucWorker(action: IChuongTrinhDaoTaoChiTietActionTypes): any {
    const request = action.payload as IChuongTrinhDaoTaoChiTietActionTypeBase<IChuongTrinhDaoTaoChiTietUpdateCongThucRequest> ;
    const res: IBaseResponse = yield call(chuongTrinhDaoTaoChiTietApi.UpdateCongThucs, request.data);
  
    if (res.is_success) {
        yield put(rootActions.chuongTrinhDaoTaoWrapper.chiTiet.UPDATE_CONG_THUC_SUCCESS({
            id_dt: request.id_dt,
            data: "Cập nhật công thức điểm thành công"
        }));
    } else {
        yield put(
            rootActions.chuongTrinhDaoTaoWrapper.chiTiet.UPDATE_CONG_THUC_ERROR({
                   id_dt: request.id_dt,
                     data: res.message ?? "Cập nhật công thức thất bại"
            })
        );
    }
}